import { Box, Typography } from '@mui/material'
import AccessTime from '@mui/icons-material/AccessTime'
import Check from '@mui/icons-material/Check'
import WarningOutlined from '@mui/icons-material/WarningOutlined'
import React from 'react'
import { CLIENT_PATH_DATES } from '../panels/client-panel/client-panel.constants'

const CLIENT_PATH_PREFIX = 'pages.application.detail.client.path'

export const ClientPath = ({ data, intl }) => {
  return (
    <Box>
      <Typography variant="subtitle2" sx={{ paddingTop: '1em', paddingBottom: '0.5em' }}>
        Seguimiento del cliente:
      </Typography>
      {CLIENT_PATH_DATES.map((el) => {
        const date = el.field(data)
        const title = (
          <Typography variant="subtitle2" sx={{ fontWeight: 'bold', padding: '0 0.3em' }}>
            {intl.formatMessage({ id: `${CLIENT_PATH_PREFIX}.${el.key}.title` })}:{' '}
          </Typography>
        )
        return (
          <Box key={el.key} display="flex" flexDirection="row" alignItems="center">
            {el.alert(data) ? (
              <>
                <WarningOutlined sx={{ paddingLeft: '0.3em', color: 'error.main' }} />
                {title}
                <Typography variant="body2" color="text.secondary">
                  {intl.formatMessage({ id: `${CLIENT_PATH_PREFIX}.${el.key}.warning` })}
                </Typography>
              </>
            ) : date ? (
              <>
                <Check sx={{ paddingLeft: '0.3em', color: 'success.main' }} />
                {title}
                <Typography variant="body2" color="text.secondary">
                  {intl.formatMessage(
                    { id: `${CLIENT_PATH_PREFIX}.${el.key}.full` },
                    { date: intl.formatDate(date) }
                  )}
                </Typography>
              </>
            ) : (
              <>
                <AccessTime sx={{ paddingLeft: '0.3em', color: 'warning.main' }} />
                {title}
                <Typography variant="body2" color="text.secondary">
                  {intl.formatMessage({ id: `${CLIENT_PATH_PREFIX}.${el.key}.empty` })}
                </Typography>
              </>
            )}
          </Box>
        )
      })}
    </Box>
  )
}

export default ClientPath
